import React from "react";

import {  injectIntl } from "react-intl";

import { withStyles } from '@material-ui/core/styles';

import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { Formik } from "formik";

import TGrid from "../../partials/content/Grid";
import { editJobService } from "../../crud/auth.crud";



const useStyles = makeStyles(theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  dense: {
    marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
}));


const styles = {
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    //marginLeft: theme.spacing(1),
    //marginRight: theme.spacing(1),
  },
  dense: {
    //marginTop: theme.spacing(2),
  },
  menu: {
    width: 200,
  },
};





class EditJobService extends React.Component {
  state = {
    
    status:false,
    statusMessage:'',
    loading:false,
    statusColor:'alert-success',
    selDate:new Date('2014-08-18T21:11:54'),
    statusList:{},
  }



  


constructor(props)
{
  super(props);
    this.state = {
      menu: false,
     
      status:false,
      statusMessage:'',
      alertType:'alert-success',
      locading:false,
      statusColor:'alert-success',
 
      
    };

    


    
  
}
  
  

  componentDidMount()
  {
    
    if(this.props.location.data.service!=null)
    {

     // console.log("service:::",this.props.location.data.service);
      this.setState({service:this.props.location.data.service});
    
    }
     
  }

  



  render() {
     const show = (this.state.menu) ? "show" : "" ;
     const status = (this.state.status);
     const alertType = (this.state.alertType);
     const statusMessage = (this.state.statusMessage);
     const loading = this.state.loading;
     const { classes } = this.props;
     const statusColor = this.state.statusColor;
    return (
      <>

          {this.state.status && (
                        <div role="alert" className={"alert "+this.state.statusColor}>
                          <div className="alert-text">{this.state.statusMessage}</div>
                        </div>
                      )}
          {this.state.service!=null &&
           <Formik
                  initialValues={{
                    serviceType:this.state.service.serviceType,
                    serviceTypeDescription:this.state.service.serviceTypeDescription,
                    price:this.state.service.price,
                  }}
                  validate={values => {
                    const errors = {};
            
                    if (!values.serviceType) {
                      errors.serviceType = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.serviceTypeDescription) {
                      errors.serviceTypeDescription = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    if (!values.price) {
                      errors.price = this.props.intl.formatMessage({
                        id: "AUTH.VALIDATION.REQUIRED_FIELD"
                      });
                    }

                    return errors;
                  }}
                  onSubmit={(values, { setStatus, setSubmitting ,setFieldValue}) => {
                    this.setState({loading:true});
                    let tStatus = this.state.service;
                    tStatus.serviceType = values.serviceType;
                    tStatus.serviceTypeDescription = values.serviceTypeDescription;
                    tStatus.price = values.price;
                    editJobService(
                      tStatus.id,
                      tStatus
                    )
                      .then(resp => {
                        //props.register(accessToken);
                        this.setState({status:true,
                        statusMessage:'Service updated successfully',
                        alertType:'alert-success',loading:false});
                         window.scrollTo(0,0);
                        
                       
                      })
                      .catch(() => {
                        this.setState({loading:false});
                      });
                  }}
                >
                  {({
                    values,
                    status,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                   
                  }) => (
                    <form onSubmit={handleSubmit} noValidate autoComplete="off">
          
                      
        	
      		<TGrid beforeCodeTitle="Package Details" jsCode="false">
        	<div className="kt-section">
	        	<div className="kt-section__content">
           

		   			
		   			<div className="row">
		   			          

                      <div className="col-12">
                        <TextField
                          margin="normal"
                          label="Service Type"
                          className="kt-width-full"
                          name="serviceType"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.serviceType}
                          helperText={touched.serviceType && errors.serviceType}
                          error={Boolean(touched.serviceType && errors.serviceType)}
                        />
                      </div>        

                      <div className="col-12">
                        <TextField
                          margin="normal"
                          label="Description"
                          className="kt-width-full"
                          name="serviceTypeDescription"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.serviceTypeDescription}
                          helperText={touched.serviceTypeDescription && errors.serviceTypeDescription}
                          error={Boolean(touched.serviceTypeDescription && errors.serviceTypeDescription)}
                        />
                      </div>      

                     

                      

                      <div className="col-12">
                        <TextField
                          margin="normal"
                          className="kt-width-full"
                          name="price"
                          label="Price ($)"
                          onChange={handleChange}
                          value={values.price}
                          helperText={touched.price && errors.price}
                          error={Boolean(touched.price && errors.price)}

                        />
                      </div>
                      
                      
		   			  </div>
             
             
				   
			    </div>
		    </div>
		    </TGrid>
        <div className="kt-login__actions">
                       

                        <button
                          disabled={isSubmitting}
                         type="submit"
                            className={`btn btn-primary btn-elevate kt-login__btn-primary ${clsx(
                              {
                                "kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light": this.state.loading
                              }
                            )}`}
                           
                          >
                           Update
                        </button>
                      </div>
       </form>
            )}
            </Formik>
          }
       
      </>
    );
  }
}

export default injectIntl(withStyles(styles)(EditJobService));

